// tslint:disable-next-line:max-line-length
import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewChild, ElementRef, HostListener, AfterViewInit, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Observable } from 'rxjs/Observable';
import { CellEditType, CellFormat } from './CellEditType';
import { IPayload as Payload } from './PayloadClass.class';
import { QtyEditorComponent } from './qtyEditor.component';
import { ICellPosition as CellPosition, ICellPosition } from './cellPosition.interface';
import { Metrix } from './metrix.interface';
import { DateEditorComponent } from './dateEditor.component';
import { SortDirection } from './sortDirection.enum';
import { IFilter } from './filter.interface';
import { ContextFilterComponent } from './filter.component';
import { ICellChangedEvent } from './cellValueChanged.event';
import { CellFocusEvent } from './cellFocus.event';
import { CellLocation } from './cellLocation.class';
import { IColumn } from './column.interface';
import { TextEditorComponent } from './textEditor.component';
import { ContextMenuComponent } from '../ContextMenu/contextMenu.component';

@Component( {
    selector: 'app-grid',
    templateUrl: 'grid.component.html',
    styleUrls: ['grid.component.css']
})

export class GridComponent implements OnChanges, AfterViewInit, OnInit
{

    maxHeight: number;
    maxWidth = 500;
    private mouseDown = false;
    private sizeHandle = false;
    private dragHandle = false;
    private sizingColumn: IColumn = null;
    private contextmenuShown = false;
    private xStart: number;
    private xEnd: number;
    private yStart: number;
    private cellStart: CellPosition;
    private pastePosition: CellPosition;
    private lastDragPosition: CellPosition;
    private selectedRow: any = null;
    private payload: Payload;
    private editTargetType: CellEditType = CellEditType.None;
    private focusRow: number;
    private focusColumn: number;
    private focusElement;
    private trackedElement;
    private trackedColor;
    private currentPage = 1;
    private numberSubscription;
    private dateChangeSubscription;
    private dateAddedSubscription;
    private clipboard: number[][];
    private rows: any[] = [];
    private allRows: any[] = [];
    private filteredRows: any[] = [];

    private hasModalDialogOpen = false;

    selectedCells: Array<CellPosition> = new Array<CellPosition>();

    @Input() columns: Array<IColumn> = new Array<IColumn>();
    @Input() totals: {};
    @Input() data: any[];
    @Input() unavailable: CellLocation[];
    @Input() parentHeight = 400;
    @Input() rowSelect = false;
    @Input() multiSelect = false;
    @Input() allowLoader = false;
    @Input() gridName: string;
    @Input() canDrag: Function;
    @Input() canDrop: Function;
    @Input() usePaging = false;
    @Input() showTotals = false;
    @Input() readOnly = false;
    @Input() pageSize = 200;
    @Input() maxButtons = 10;
    @Input() rowHidden: Function;
    @Output() dragStart = new EventEmitter<Payload>();
    @Output() dragEnd = new EventEmitter<Payload>();
    @Output() rowClick = new EventEmitter<any>();
    @Output() error = new EventEmitter<string>();
    @Output() rowAdded = new EventEmitter<any>();
    @Output() cellValueChanged = new EventEmitter<any>();
    @Output() onCellFocus = new EventEmitter<ICellPosition>();

    @ViewChild( 'headerRow' ) header: ElementRef;
    @ViewChild( 'hr' ) hr: ElementRef;
    @ViewChild( 'table' ) table: ElementRef;
    @ViewChild( 'txtEditor' ) txtEditor: TextEditorComponent;
    @ViewChild( 'numEditor' ) numEditor: QtyEditorComponent;
    @ViewChild( 'dateEditor' ) dateEditor: DateEditorComponent;
    @ViewChild( 'contextFilter' ) contextFilter: ContextFilterComponent;
    @ViewChild( 'contextMenu' ) contextMenu: ContextMenuComponent;
    @ViewChild( 'pageArea' ) pageArea: ElementRef;

    constructor( private el: ElementRef, private sanitizer: DomSanitizer )
    {

    }

    private get dataLength(): number
    {
        return this.filteredRows ? this.filteredRows.length : 0;
    }

    private get dataSource(): any[]
    {
        if ( !this.columnFilters() )
        {
            this.filteredRows = this.data;
        }

        if ( !this.usePaging )
        {
            return this.filteredRows;
        }
        return this.showPage();
    }

    private columnFilters(): boolean
    {
        for ( let col of this.columns )
        {
            if ( col.canFilter && col.filterValue )
            {
                return true;
            }
        }
        return false;
    }

    public getCellElement( rowIndex: number, colIndex: number ): any
    {
        if ( this.table && this.table.nativeElement && this.table.nativeElement.rows[rowIndex] )
        {
            return this.table.nativeElement.rows[rowIndex].cells[colIndex];
        }
        return null;
    }

    totalFor( row: number, col: IColumn )
    {
        if ( this.totals && this.totals[row] )
        {
            return this.totals[row][col.field];
        }
        return '';
    }

    setMaxHeight()
    {
        let pagerHeight = ( this.pageArea ) ? this.pageArea.nativeElement.clientHeight : 0;
        this.maxHeight = this.el.nativeElement.parentElement.clientHeight
            - this.header.nativeElement.clientHeight
            - this.el.nativeElement.parentElement.offsetTop
            - pagerHeight;
    }

    setMaxWidth()
    {

        let width = 0;
        for ( let col of this.columns )
        {
            width += col.width;
        }

        this.maxWidth = Math.max( width, this.el.nativeElement.parentElement.clientWidth );
    }

    defaultYesNoFormatter( row, col ): SafeHtml
    {
        return this.sanitizer.bypassSecurityTrustHtml( '<div><input type="checkbox" /></div>' );
    }

    addColumns( cols: IColumn[], reset: boolean )
    {
        if ( reset )
        {
            this.columns.length = 0;
        }
        for ( let col of cols )
        {
            this.columns.push( col );
        }
    }

    formatter( row: any, col: IColumn ): SafeHtml
    {
        if ( !row )
        {
            return '';
        }
        if ( col.formatter )
        {
            return col.formatter( row, col );
        }

        switch ( col.cellType )
        {
            case CellEditType.Text:
                break;
            case CellEditType.Number:
                break;
            case CellEditType.Date:
                break;
            case CellEditType.YesNo:
                return this.defaultYesNoFormatter( row, col );
        }

        return ( row[col.field] ? row[col.field] : '' );
    }

    formatTotal( col: IColumn )
    {
        // if ( col.canTotal )
        // {
        //     if ( col.totalFormatter )
        //     {
        //         return col.totalFormatter( this.rows, col );
        //     }

        //     var total: number = 0;

        //     if ( col.cellFormat === CellFormat.Number || col.cellFormat == CellFormat.Money )
        //     {
        //         console.log('total');

        //         for ( let row of this.rows )
        //         {
        //             total += this.isNumericString(row[col.field]) ? +row[col.field] : 0;
        //         }
        //         return total.toLocaleString( 'ZA-EN', {
        //             minimumFractionDigits: col.cellFormat === CellFormat.Number ? 0 : 2
        //         });
        //     }
        // }

        return '';
    }

    pageChanged( e )
    {
        this.currentPage = e.newpage;
        this.rows = this.dataSource;
    }

    showPage(): any[]
    {
        let arr = [];
        let begin = ( this.currentPage - 1 ) * this.pageSize;
        for ( let i = 0; i < this.pageSize; i++ )
        {
            if ( begin + i < this.filteredRows.length )
            {
                arr.push( this.filteredRows[begin + i] );
            }
        }
        return arr;
    }

    dateValue( row: any, col: IColumn ): Date
    {
        return new Date( row[col.field] );
    }

    qtyChanged( e: ICellChangedEvent )
    {
        let originalValue = e.row[e.col.field];

        e.row[e.col.field] = e.newValue;
        e.row.hasChanged = true;

        this.cellValueChanged.emit( {
            row: e.row,
            col: e.col,
            newValue: e.newValue,
            oldValue: originalValue,
            cancel: () =>
            {
                e.row[e.col.field] = originalValue;
                e.row.hasChanged = false;
            }
        });
    }

    txtChanged( e: ICellChangedEvent )
    {
        let originalValue = e.row[e.col.field];

        e.row[e.col.field] = e.newValue;
        e.row.hasChanged = true;

        this.cellValueChanged.emit( {
            row: e.row,
            col: e.col,
            newValue: e.newValue,
            oldValue: originalValue,
            cancel: () =>
            {
                e.row[e.col.field] = originalValue;
                e.row.hasChanged = false;
            }
        });
    }

    dateChanged( e: ICellChangedEvent )
    {
        let originalValue = e.row[e.col.field];

        e.row[e.col.field] = e.newValue;
        e.row.hasChanged = true;

        this.cellValueChanged.emit( {
            row: e.row,
            col: e.col,
            newValue: e.newValue,
            cancel: () =>
            {
                e.row[e.col.field] = originalValue;
                e.row.hasChanged = false;
            }
        });
    }

    checkChanged( e: ICellChangedEvent )
    {
        e.row[e.col.field] = e.newValue;
        e.row.hasChanged = true;
    }

    onCellClicked( rowIndex: number, colIndex: number, e )
    {
        if ( this.hasFocus( rowIndex, colIndex ) )
        {
            this.trackedElement.style.backgroundColor = 'aliceblue';
            this.startEditing();
        }
        else
        {
            this.moveFocus( rowIndex, colIndex, this.focusRow, this.focusColumn );
        }
    }

    contextMenuClicked( e )
    {
        this.contextmenuShown = false;
        if ( e === 'Copy' )
        {
            if ( this.selectionCanBeCopied() )
            {
                this.copySelectionToClipboard();
            }
        }
        else if ( e === 'Paste' )
        {
            if ( this.clipboard.length > 0 )
            {
                this.pasteFromClipboard();
            }
        }
    }

    private filter( col: IColumn )
    {
        if ( !col.filterValue )
        {
            col.filterValue = '';
        }
        col.showFilter = col.showFilter ? !col.showFilter : true;
        if ( col.showFilter )
        {
            this.contextFilter.showFilter( this.xStart, this.yStart, col );
        }
    }

    private onFilterChanged( filter: IFilter )
    {
        this.currentPage = 1;
        filter.column.filterValue = filter.value;
        this.filteredRows = [];
        for ( let i = 0; i < this.data.length; i++ )
        {
            let ok = true;
            for ( let c = 0; c < this.columns.length; c++ )
            {
                let col = this.columns[c];
                if ( col.canFilter && col.filterValue && col.filterValue.length > 0 )
                {
                    if ( !this.data[i][col.field] || this.data[i][col.field].toLowerCase().indexOf( col.filterValue.toLowerCase() ) === -1 )
                    {
                        ok = false;
                        break;
                    }
                }
            }
            if ( ok )
            {
                this.filteredRows.push( this.data[i] );
            }
        }
        this.rows = this.dataSource;
        this.clearSortButtons();
    }

    clearSortButtons( except: IColumn = null )
    {
        for ( let c of this.columns )
        {
            if ( !except || c !== except )
            {
                c.sortDirection = SortDirection.None;
            }
        }
    }

    swapSortDirection( col: IColumn )
    {
        switch ( col.sortDirection )
        {
            case SortDirection.None:
                col.sortDirection = SortDirection.Ascending;
                break;
            case SortDirection.Ascending:
                col.sortDirection = SortDirection.Descending;
                break;
            case SortDirection.Descending:
                col.sortDirection = SortDirection.Ascending;
                break;
        }
    }

    private initialSort()
    {
        for ( let col of this.columns )
        {
            if ( col.canSort && col.sortDirection != null && col.sortDirection !== SortDirection.None )
            {
                this.swapSortDirection( col );
                this.sort( col );
                break;
            }
        }
    }

    private sort( col: IColumn )
    {
        if ( !col.canSort )
        {
            return;
        }

        this.swapSortDirection( col );
        this.sortTheData( col );
        this.clearSortButtons( col );
    }

    private sortTheData( col: IColumn )
    {
        if ( !this.filteredRows || this.filteredRows.length === 0 )
        {
            return;
        }
        this.filteredRows.sort(( a, b ) =>
        {
            if ( col.compare )
            {
                return col.compare( col.sortDirection, a[col.field], b[col.field] );
            }
            if ( a[col.field] > b[col.field] )
            {
                return col.sortDirection === SortDirection.Ascending ? 1 : -1;
            }
            if ( a[col.field] < b[col.field] )
            {
                return col.sortDirection === SortDirection.Ascending ? -1 : 1;
            }
            return 0;
        });
        this.rows = this.dataSource;
    }

    private selectionCanBeCopied(): boolean
    {
        return true;
    }

    private getClipboardMetrix(): Metrix
    {
        let retVal: Metrix = new Metrix(
            0,
            this.clipboard.length - 1,
            0,
            this.clipboard.length > 0 ? this.clipboard[0].length - 1 : 0
        );
        return retVal;
    }

    private getSelectionMetrix(): Metrix
    {
        if ( !this.selectedCells || this.selectedCells.length === 0 )
        {
            return new Metrix( 0, 0, 0, 0 );
        }

        let retVal: Metrix = new Metrix(
            Math.min.apply( Math, this.selectedCells.map( o => o.row ) ),
            Math.max.apply( Math, this.selectedCells.map( o => o.row ) ),
            Math.min.apply( Math, this.selectedCells.map( o => o.col ) ),
            Math.max.apply( Math, this.selectedCells.map( o => o.col ) )
        );
        return retVal;
    }

    private copySelectionToClipboard(): void
    {

        this.clipboard = [];

        if ( this.selectedCells.length === 0 )
        {
            this.clipboard[0] = [];
            this.clipboard[0][0] = this.rows[this.focusRow - 1][this.columns[this.focusColumn].field];
            return;
        }
        let selectionMetrix = this.getSelectionMetrix();

        for ( let i = 0; i <= selectionMetrix.maxrow - selectionMetrix.minrow; i++ )
        {
            this.clipboard[i] = [];
        }

        for ( let qty of this.selectedCells )
        {
            this.clipboard[qty.row - selectionMetrix.minrow][qty.col - selectionMetrix.mincol] = this.rows[qty.row][this.columns[qty.col].field];
        }
    }

    private pasteFromClipboard(): void
    {
        let selectionMetrix = this.getSelectionMetrix();
        let clipMetrix = this.getClipboardMetrix();

        if ( this.clipboard.length === 1 && this.clipboard[0].length === 1 )
        {

            // we are pasting a single cell value
            this.pasteOneCellToMany( selectionMetrix );
            return;
        }

        if ( selectionMetrix.height === 1 && selectionMetrix.width === 1 )
        {

            // we are pasting to a single cell
            this.pasteBlockToPosition( clipMetrix );
        }

        if ( clipMetrix.height === 1 )
        {

            // we are pasting one row to one or more rows
            this.pasteOneRowToMany( clipMetrix, selectionMetrix );
            return;
        }

        if ( clipMetrix.height > 1 && selectionMetrix.height > 1 )
        {

            // we are pasting a block to a block
            this.pasteBlockToBlock( clipMetrix, selectionMetrix );
        }
    }

    private pasteBlockToBlock( clipMetrix: Metrix, selMetrix: Metrix )
    {

        // validate the shape
        if ( clipMetrix.width !== selMetrix.width )
        {
            this.error.emit( 'Shape accross is diffent cannot paste' );
            return;
        }

        if ( clipMetrix.height !== selMetrix.height )
        {
            this.error.emit( 'Shape down is different cannot paste' );
            return;
        }

        for ( let clip = clipMetrix.minrow; clip <= clipMetrix.maxrow; clip++ )
        {
            this.pasteRow( this.clipboard[clip], selMetrix.minrow + clip, selMetrix.mincol );
        }

        this.clipboard.length = 0;
    }

    private pasteBlockToPosition( clipMetrix: Metrix )
    {

        for ( let clip = clipMetrix.minrow; clip <= clipMetrix.maxrow; clip++ )
        {
            this.pasteRow( this.clipboard[clip], this.focusRow - 1 + clip, this.focusColumn );
        }
        this.clipboard.length = 0;
    }

    private pasteOneRowToMany( clipMetrix: Metrix, selMetrix: Metrix )
    {
        // validate the shape
        if ( clipMetrix.width !== selMetrix.width && selMetrix.width > 1 )
        {
            this.error.emit( 'Shape accross is diffent cannot paste' );
            return;
        }

        for ( let sel = selMetrix.minrow; sel <= selMetrix.maxrow; sel++ )
        {
            if ( !this.rowHidden || ( this.rowHidden && !this.rowHidden( this.rows[sel] ) ) )
            {
                this.pasteRow( this.clipboard[0], sel, selMetrix.mincol );
            }
        }
        this.clipboard.length = 0;
    }

    private pasteOneCellToMany( selMetrix: Metrix )
    {
        if ( selMetrix.height === 1 && selMetrix.width === 1 )
        {
            if ( this.focusRow && this.focusColumn )
            {
                let e: ICellChangedEvent = {
                    row: this.rows[this.focusRow - 1],
                    col: this.columns[this.focusColumn],
                    oldValue: this.rows[this.focusRow - 1][this.columns[this.focusColumn].field],
                    newValue: this.clipboard[0][0],
                    cancel: ( can: ICellChangedEvent ) =>
                    {
                        e.row[e.col.field] = can.oldValue;
                    }
                };

                this.rows[this.focusRow - 1].hasChanged = true;
                this.rows[this.focusRow - 1][this.columns[this.focusColumn].field] = this.clipboard[0][0];
                this.cellValueChanged.emit( e );
            }
        } else
        {
            for ( let row = selMetrix.minrow; row <= selMetrix.maxrow; row++ )
            {
                if ( this.rowHidden(this.rows[row]) ) 
                {
                    continue;
                }    
                for ( let col = selMetrix.mincol; col <= selMetrix.maxcol; col++ )
                {
                    let e: ICellChangedEvent = {
                        row: this.rows[row],
                        col: this.columns[col],
                        oldValue: this.rows[row][this.columns[col].field],
                        newValue: this.clipboard[0][0],
                        cancel: ( ch: ICellChangedEvent ) =>
                        {
                            e.row[e.col.field] = ch.oldValue;
                        }
                    };

                    this.rows[row].hasChanged = true;
                    this.rows[row][this.columns[col].field] = this.clipboard[0][0];
                    this.cellValueChanged.emit( e );
                }
            }
        }

        this.clipboard.length = 0;
    }

    private pasteRow( source: number[], destX: number, destY: number )
    {
        if ( !source )
        {
            return;
        }

        for ( let i = 0; i < source.length; i++ )
        {
            if ( this.columns[destY + i].cellType !== CellEditType.None )
            {
                let e: ICellChangedEvent = {
                    row: this.rows[destX],
                    col: this.columns[destY + i],
                    oldValue: this.rows[destX][this.columns[destY + i].field],
                    newValue: source[i],
                    cancel: ( ch: ICellChangedEvent ) =>
                    {
                        e.row[e.col.field] = ch.oldValue;
                    }
                };

                this.rows[destX].hasChanged = true;
                this.rows[destX][this.columns[destY + i].field] = source[i];
                this.cellValueChanged.emit( e );
            }
        }
    }

    private hasFocus( rowIndex: number, colIndex: number ): boolean
    {
        return rowIndex == this.focusRow && colIndex == this.focusColumn;
    }

    private removeFocus(from: string)
    {
        // console.log('remove focus: ' + from);
        if ( this.focusElement )
        {
            this.focusElement.style.borderColor = 'lightsteelblue';
            this.focusElement = null;
        }

        if ( this.trackedElement )
        {
            this.trackedElement.style.backgroundColor = 'aliceblue';
        }

        this.focusRow = null;
        this.focusColumn = null;
    }

    private moveFocus( newRowIndex: number, newColIndex: number, oldRowIndex: number, oldColIndex: number )
    {
        // console.log( 'Move:' + newRowIndex + ',' + newColIndex );
        if ( newRowIndex < 0 || newColIndex < 0 || newRowIndex == null || newColIndex == null )
        {
            return;
        }

        if ( this.columns[newColIndex] && this.columns[newColIndex].cellType === CellEditType.None )
        {
            this.flashExistingFocus();
            return;
        }
        
        let focusEvent: CellFocusEvent = {
            row: newRowIndex - 1,
            col: newColIndex,
            cancel: () =>
            {
                this.focusRow = oldRowIndex;
                this.focusColumn = oldColIndex;
                // this.focusElement = this.table.nativeElement.rows[oldRowIndex].cells[oldColIndex];
                // this.focusElement.style.borderColor = 'red';

                // return;
            },
            proceed: () =>
            {
                this.focusRow = newRowIndex;
                this.focusColumn = newColIndex;

                if ( this.focusElement )
                {
                    this.focusElement.style.borderColor = 'lightsteelblue';
                }

                this.focusElement = this.table.nativeElement.rows[this.focusRow].cells[this.focusColumn];
                this.focusElement.style.borderColor = 'black';
                this.editTargetType = this.columns[this.focusColumn].cellType;
            }
        };

        this.onCellFocus.emit( focusEvent );
    }

    private flashExistingFocus()
    {
        if ( this.focusElement != null )
        {
            let flashCount = 3;
            let clr = 'black';
            let width = 3;
            let intervalId = setInterval(() =>
            {
                clr = clr == 'black' ? 'red' : 'black';
                width = clr == 'black' ? 1 : 3;
                this.focusElement.style.borderColor = clr;
                this.focusElement.style.borderWidth = width;
                if ( flashCount-- == 0 )
                {
                    clearInterval( intervalId );
                }
            }, 300 );
        }
    }

    private selectedClass( rowIndex: number, colIndex: number )
    {
        if ( this.inSelection( rowIndex, colIndex ) )
        {
            return 'in-selection';
        }
        return '';
    }

    private addEnclosedSelection( rowIndex: number, colIndex: number, from: string )
    {
        for ( let i = this.selectedCells.length - 1; i >= 0; i-- )
        {
            if ( this.selectedCells[i].row > rowIndex || this.selectedCells[i].col > colIndex )
            {
                this.selectedCells.splice( i, 1 );
            }
        }
        

        if ( this.cellStart.col === colIndex && this.cellStart.row == rowIndex )
        {
            this.selectedCells.length = 0;
            return;
        }

        for ( let x = this.cellStart.col; x <= colIndex; x++ )
        {
            for ( let y = this.cellStart.row; y <= rowIndex; y++ )
            {
                this.addToSelection( y, x, 'add enclosed: ' + from);
            }
        }
    }

    private addToSelection( rowIndex: number, colIndex: number, from: string )
    {
        this.removeFocus('add selection: ' + from);
        if ( !this.inSelection( rowIndex, colIndex ) )
        {
            this.selectedCells.push( {
                row: rowIndex,
                col: colIndex
            });
        }
    }

    private inSelection( rowIndex: number, colIndex: number ): boolean
    {
        return ( this.selectedCells.some(( cell ) => { return cell.row === rowIndex && cell.col === colIndex; }) );
    }

    isUnavailable( r: number, c: string ): string
    {
        // console.log('unav');
        if ( this.unavailable )
        {
            for ( let cell of this.unavailable )
            {
                if ( cell.row === r && cell.column === c )
                {
                    return 'unavailable';
                }
            }
        }
        return '';
    }

    startEditing(): void
    {

        if ( this.columns[this.focusColumn].cellType === CellEditType.DateAdd || this.columns[this.focusColumn].cellType === CellEditType.Date )
        {
            this.hasModalDialogOpen = true;
            this.dateEditor.takeFocus( this.xStart, this.yStart, this.rows[this.focusRow - 1] );
            if ( this.dateChangeSubscription )
            {
                this.dateChangeSubscription.unsubscribe();
            }
            this.dateChangeSubscription = this.dateEditor.dateChanged.subscribe(( e: ICellChangedEvent ) =>
            {
                let field = e.col.field;
                e.row[field] = e.newValue;
                e.row.hasChanged = true;
                this.removeFocus('start edit 1');
                this.dateChangeSubscription.unsubscribe();
                this.dateAddedSubscription.unsubscribe();
                this.hasModalDialogOpen = false;
            });
            if ( this.dateAddedSubscription )
            {
                this.dateAddedSubscription.unsubscribe();
            }
            this.dateAddedSubscription = this.dateEditor.dateAdded.subscribe(( e: ICellChangedEvent ) =>
            {
                this.rowAdded.emit( {
                    date: e.newValue,
                    row: this.rows[this.focusRow - 1]
                });
                this.removeFocus('start edit 2');
                this.dateAddedSubscription.unsubscribe();
                this.dateChangeSubscription.unsubscribe();
                this.hasModalDialogOpen = false;
            });
        }
    }

    private isNumberCloseTo( value1: number, value2: number, precision = 10 ): boolean
    {
        let diff: number = Math.abs( value1 - value2 );
        return diff < precision;
    }

    canBeDragged( row, col: IColumn ): boolean
    {
        if ( col && col.field )
        {
            this.dragHandle = this.canDrag && this.canDrag( row, col );
        } else
        {
            this.dragHandle = false;
        }
        return this.dragHandle;
    }

    isNumericString( n )
    {
        return !isNaN( parseFloat( n ) ) && isFinite( n );
    }

    isNumericChar( char: number ): boolean
    {

        if ( char > 47 && char < 58 )
        {
            return true;
        }
        return false;
    }

    private getRowIndex( id: string ): number
    {
        if ( id.indexOf( ',' ) > -1 )
        {
            return +id.substring( 0, id.indexOf( ',' ) );
        }
        return -1;
    }

    private getColumnIndex( id: string ): number
    {
        if ( id.indexOf( ',' ) > -1 )
        {
            return +id.substring( id.indexOf( ',' ) + 1 );
        }
        return -1;
    }

    getClasses( row, col: IColumn ): string
    {
        let comma = '';
        let result = '{';
        for ( let cls of col.cellClass )
        {
            result += ( comma + "'" + cls + "': true" );
            comma = ',';
        }
        result += '}';
        return result;
    }

    private restoreColumns()
    {
        for ( let col of this.columns )
        {
            let key = this.gridName + '.' + col.field;
            let width = localStorage.getItem( key );
            if ( width )
            {
                col.width = JSON.parse( width );
            }
            if ( col.width < 0 )
            {
                col.width = 80;
                localStorage.setItem( key, JSON.stringify( col.width ) );
            }
        }
    }

    private saveColumns()
    {
        for ( let col of this.columns )
        {
            let key = this.gridName + '.' + col.field;
            localStorage.setItem( key, JSON.stringify( col.width ) );
        }
    }

    ngOnChanges( changes: SimpleChanges )
    {

        if ( changes['parentHeight'] )
        {
            this.setMaxHeight();
        };
        if ( changes['data'] )
        {
            this.rows = [];
            this.selectedCells.length = 0;
            this.restoreColumns();
            this.setMaxHeight();
            this.setMaxWidth();
            this.removeFocus('on changes');
            setTimeout(() =>
            {
                this.rows = this.dataSource;
                setTimeout(() =>
                {
                    this.initialSort();
                }, 10 );
            }, 10 );

            // // make a copy of the original data            
            // this.allRows = JSON.parse( JSON.stringify( this.rows ) );

            // if ( this.usePaging ) {
            //     this.rows.length = 0;
            //     this.showPage();
            // }
        }
    }

    onRowClicked( clickedRow: any )
    {
        if ( this.selectedRow )
        {
            this.selectedRow.current = false;
        }
        this.selectedRow = clickedRow;
        clickedRow.current = true;
        this.rowClick.emit( clickedRow );
    }

    ngAfterViewInit(): void
    {
        setTimeout( _ =>
        {
            this.setMaxHeight();
            this.setMaxWidth();
            this.restoreColumns();
        });
    }

    ngOnInit(): void
    {
        Observable.fromEvent( window, 'resize' )
            .throttleTime( 250 )
            .subscribe( e =>
            {
                this.setMaxHeight();
                this.setMaxWidth();

            });
        Observable.fromEvent( window, 'keyup' )
            .subscribe( e =>
            {
                this.onKeyPress( e );

            });
    }

    onContextMenu( e )
    {
        e.preventDefault();

        if ( !this.focusElement && ( !this.selectedCells || this.selectedCells.length === 0 ) )
        {
            return;
        }
        let items = [];
        items.push( { 'glyph': 'glyphicon-copy', 'text': 'Copy' });
        if ( this.clipboard && this.clipboard.length > 0 )
        {
            items.push( { 'glyph': 'glyphicon-paste', 'text': 'Paste' });
        }

        this.contextmenuShown = true;
        this.contextMenu.showMenu( e, items );
        return false;
    }

    previousEditableRow(): number
    {
        if ( this.focusRow > 1 )
        {
            let nextRow = this.focusRow - 1;
            while ( nextRow > 0 )
            {
                if ( !this.table.nativeElement.rows[nextRow].hidden )
                {
                    return nextRow;
                }
                nextRow--;
            }
        }
        return this.focusRow;
    }

    nextEditableRow(recursion: number): number
    {
        let nextRow = this.focusRow + 1;
        let maxRows = this.table.nativeElement.rows.length - ( this.showTotals ? 1 : 0 );
        while ( nextRow < maxRows )
        {
            if ( !this.table.nativeElement.rows[nextRow].hidden )
            {
                return nextRow;
            }
            nextRow++;
        }
        if ( ++recursion < 10 )
        {
            this.focusRow = 0;
            return this.nextEditableRow( recursion );
        }
        return this.focusRow;
    }

    setNextEditableCell()
    {
        let nextCol: number = this.focusColumn + 1;

        // the grid always has a blank column at the end to make it look nice, that's why length-2
        while (
            (this.columns[nextCol].cellType == CellEditType.None || !this.isNumericString( this.rows[this.focusRow - 1][this.columns[nextCol].field] )) &&
            nextCol < this.table.nativeElement.rows[0].cells.length - 2
        )
        {
            nextCol++;
        }

        if ( this.columns[nextCol].cellType !== CellEditType.None && this.isNumericString( this.rows[this.focusRow - 1][this.columns[nextCol].field] ) )
        {
            this.focusColumn = nextCol;
            return;
        }

        this.focusColumn = 0;
        this.focusRow = this.nextEditableRow(0);

        if ( this.focusRow < this.table.nativeElement.rows.length )
        {
            this.setNextEditableCell();
        }
        return;
    }

    onKeyPress( e )
    {
        if ( !this.focusElement )
        {
            return;
        }
        if ( e.key === 'ArrowUp' )
        {
            // check for row 2 because the header row is there at position zero
            if ( this.focusRow > 1 )
            {
                this.moveFocus( this.previousEditableRow(), this.focusColumn, this.focusRow, this.focusColumn );
            }
        }
        else if ( e.key === 'ArrowDown' || e.key === 'Enter' )
        {
            this.moveFocus( this.nextEditableRow(0), this.focusColumn, this.focusRow, this.focusColumn );
        }
        else if ( e.key === 'ArrowLeft' && this.focusColumn > 0 )
        {
            if ( this.columns[this.focusColumn - 1].cellType !== CellEditType.None )
            {
                this.moveFocus( this.focusRow, this.focusColumn - 1, this.focusRow, this.focusColumn );
            }
        }
        else if ( e.key === 'ArrowRight' )
        {
            if ( this.focusColumn < this.table.nativeElement.rows[0].cells.length - 1 && this.columns[this.focusColumn + 1].cellType !== CellEditType.None )
            {
                this.moveFocus( this.focusRow, this.focusColumn + 1, this.focusRow, this.focusColumn );
            }
        }
        else if ( e.key === 'Tab' )
        {
            let currentRow = this.focusRow;
            let currentCol = this.focusColumn;
            this.setNextEditableCell();
            this.moveFocus( this.focusRow, this.focusColumn, currentRow, currentCol );
        }
    }

    private determineCursor( el: Element, rowIndex: number, colIndex: number, mouseX: number, mouseY: number )
    {

        let col = this.columns[colIndex];

        if ( el.id.indexOf( 'h' ) > -1 )
        {
            if ( col.canResize )
            {
                let rect = el.getBoundingClientRect();
                if ( this.isNumberCloseTo( mouseX, rect.right ) )
                {
                    this.sizeHandle = true;
                    return 'col-resize';
                }
            }
            this.sizeHandle = false;
        } else
        {

            if ( !this.payload )
            {
                if ( this.canBeDragged( this.rows[rowIndex - 1], col ) )
                {
                    return 'ew-resize';
                }
            } else
            {
                let newPayload = {
                    row: this.rows[rowIndex - 1],
                    col: col,
                    payload: this.payload
                };
                if ( this.canDrop && this.canDrop( newPayload ) )
                {
                    return 'crosshair';
                }
                return 'no-drop';
            }
        }
        return 'auto';
    }

    onMouseEnter( e )
    {
        let colIndex = this.getColumnIndex( e.target.id );

        if ( this.columns[colIndex].cellType !== CellEditType.None )
        {
            this.trackedColor = e.target.style.backgroundColor;
            e.target.style.backgroundColor = '#C8E6FF';
            this.trackedElement = e.target;
        }
    }

    onMouseLeave( e )
    {
        let colIndex = this.getColumnIndex( e.target.id );

        if ( this.columns[colIndex].cellType !== CellEditType.None )
        {
            e.target.style.backgroundColor = this.trackedColor;
            this.trackedElement = null;
        }
    }

    onMouseDown( e )
    {
        let closest = e.target.closest( 'td,th' );
        if ( !closest )
        {
            return;
        }
        let rowIndex = this.getRowIndex( closest.id );
        let colIndex = this.getColumnIndex( closest.id );

        if ( e.button === 2 )
        {
            this.moveFocus( rowIndex, colIndex, this.focusRow, this.focusColumn );
            return;
        }
        e.preventDefault();
        this.mouseDown = true;
        this.xStart = e.clientX;
        this.yStart = e.clientY;


        if ( e.shiftKey )
        {
            this.addEnclosedSelection( rowIndex - 1, colIndex, 'mouse down' );
            return;
        }

        this.cellStart = {
            row: rowIndex - 1,
            col: colIndex
        };

        if ( !this.contextmenuShown && e.button !== 2 )
        {
            this.selectedCells.length = 0;
            this.contextmenuShown = false;

            // this.moveFocus( rowIndex, colIndex, this.focusRow, this.focusColumn );
        }

        if ( this.sizeHandle )
        {
            // var index = e.target.id.substring( e.target.id.indexOf( ',' ) + 1 );
            this.sizingColumn = this.columns[colIndex];
        } else if ( this.dragHandle )
        {
            this.payload = { row: this.rows[rowIndex - 1], col: this.columns[colIndex] };
            this.dragStart.emit( this.payload );
        }
    }

    onMouseUp( e )
    {
        let closest = e.target.closest( 'td,th' );
        if ( !closest )
        {
            return;
        }

        let rowIndex = this.getRowIndex( closest.id );
        let colIndex = this.getColumnIndex( closest.id );

        if ( e.button === 2 )
        {
            this.pastePosition = {
                row: rowIndex - 1,
                col: colIndex
            };
            return;
        }

        e.preventDefault();

        if ( e.ctrlKey )
        {
            this.addToSelection( rowIndex - 1, colIndex, 'mouse up' );
        } else
        {
            if ( !this.contextmenuShown && this.cellStart.row === rowIndex - 1 && this.cellStart.col === colIndex )
            {
                this.selectedCells.length = 0;
            }
        }

        this.xEnd = e.clientX;

        if ( this.sizingColumn )
        {
            this.sizingColumn.width += ( this.xEnd - this.xStart );
            this.saveColumns();
        }

        this.mouseDown = false;
        this.dragHandle = false;
        this.sizeHandle = false;
        this.sizingColumn = null;

        if ( this.payload )
        {
            let newPayload = {
                row: this.rows[rowIndex - 1],
                col: this.columns[colIndex],
                payload: this.payload
            };

            this.dragEnd.emit( newPayload );
            this.payload = null;
        }
        if ( colIndex > -1 )
        {
            this.determineCursor( closest, rowIndex, colIndex, e.x, e.y );
        }
    }

    onMouseMove( e )
    {
        if ( this.hasModalDialogOpen )
        {
            return;
        }
        e.preventDefault();

        if ( this.sizingColumn && this.mouseDown )
        {
            return;
        }
        let closest = e.target.closest( 'td,th' );
        if ( !closest )
        {
            return;
        }
        let rowIndex = this.getRowIndex( closest.id );
        let colIndex = this.getColumnIndex( closest.id );

        if ( colIndex > -1 )
        {
            // this.el.nativeElement.style.cursor = this.determineCursor( closest, rowIndex, colIndex, e.x, e.y );
            this.hr.nativeElement.style.cursor = this.determineCursor( closest, rowIndex, colIndex, e.x, e.y );
        }

        if ( !this.mouseDown )
        {
            return;
        }

        if ( this.editTargetType
            && this.lastDragPosition
            && this.lastDragPosition.row === rowIndex - 1
            && this.lastDragPosition.col === colIndex )
        {
            return;
        }

        if ( !this.multiSelect )
        {
            return;
        }

        this.addEnclosedSelection( rowIndex - 1, colIndex, 'mouse move' );
        this.lastDragPosition = {
            row: rowIndex - 1,
            col: colIndex
        };
    }

}



// WEBPACK FOOTER //
// ./src/app/components/Grid/grid.component.ts